import { render, staticRenderFns } from "./TrPage.vue?vue&type=template&id=116e4580&scoped=true&"
import script from "./TrPage.vue?vue&type=script&lang=js&"
export * from "./TrPage.vue?vue&type=script&lang=js&"
import style0 from "./TrPage.vue?vue&type=style&index=0&id=116e4580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e4580",
  null
  
)

export default component.exports